import { useField } from 'formik'
import React from 'react'

import TextArea from 'components/common/TextArea'

type FormFieldTextAreaProps = {
  name: string
  subtext?: string
  label?: string
}

const FormFieldTextArea: React.FC<
  FormFieldTextAreaProps & Omit<React.HTMLProps<HTMLTextAreaElement>, 'ref'>
> = ({ name, subtext, ...props }) => {
  const [fieldProps, { touched, error }] = useField(name)
  return (
    <TextArea
      {...fieldProps}
      isInvalid={error && touched}
      subtext={error && touched ? error : subtext}
      {...props}
    />
  )
}

export default FormFieldTextArea
